import React from "react";
import SingleLevelDrilldown from "../../components/Drilldown/SingleLevelDrilldown";
import Drilldown from "../../components/Drilldown/DrilldownWithSLD";
import DrilldownSLDNewv2 from "../../RepPerformance/GenericScorecard/DrilldownSLDNewv2";
import ExpectedAcvPageLegacy from "../../RepPerformance/ScoreCard/ExpectedAcv/ExpectedAcvPage";
import ExpectedAcvPageWaterfall from "../../EnhancedInsights/NewWaterFall/ExpectedAcvPage";

/**
 * RCC drilldown modals renderer.
 * Pure UI: expects state + handlers from `useRccDrilldowns`.
 */
export default function RccDrilldownModals({
  drilldownLocation,
  secondLevelLocation,
  handleChangeLocationBack,
  handleSecondLevelDrilldown,
  stepBack,
  drilldownOnGraphData,
  ExpectedAcvData,
  EnsembleData,
  PipelineCoverageCFQ,
  Value_Label,
  company,
  Win_Rate_Prefix,
  LOCATIONS,
}) {
  return (
    <>
      {/* Qualified Pipeline Drilldown (Qtr Projection) */}
      {drilldownLocation === LOCATIONS.QUALIFIED_PIPELINE && (
        <SingleLevelDrilldown
          header="Qualified Pipeline Current Quarter Close"
          back={handleChangeLocationBack}
          filters={[]}
          Value_Label={Value_Label}
        >
          {EnsembleData && EnsembleData.expectedHighMidLow ? (
            <DrilldownSLDNewv2
              Value_Label={Value_Label}
              header="Qualified Pipeline Current Quarter Close"
              body={drilldownOnGraphData}
              showLowMidHigh={true}
              showSLD={true}
              handleSecondLevelDrilldown={handleSecondLevelDrilldown}
              pipeline={
                PipelineCoverageCFQ &&
                PipelineCoverageCFQ.data &&
                PipelineCoverageCFQ.data.find((i) => i.name === "company")
              }
              expectedHighMidLow={EnsembleData.expectedHighMidLow}
              qualifiedPipeline={EnsembleData.qualifiedPipeline}
              uniqueNames={EnsembleData.uniqueNames}
              quarterLastDate={EnsembleData.quarterLastDate}
              fiscalQuarter={EnsembleData.fiscalQuarter}
              splitType={EnsembleData.splitType}
            />
          ) : (
            <Drilldown
              Value_Label={Value_Label}
              header="Qualified Pipeline Current Quarter Close"
              body={drilldownOnGraphData}
              handleSecondLevelDrilldown={handleSecondLevelDrilldown}
            />
          )}
        </SingleLevelDrilldown>
      )}

      {/* Won Opportunities Drilldown (QTD/YTD Bookings) */}
      {drilldownLocation === LOCATIONS.WON_OPPORTUNITIES && (
        <SingleLevelDrilldown
          header="Won Opportunities"
          back={handleChangeLocationBack}
          filters={[]}
        >
          <Drilldown
            Value_Label={Value_Label}
            header="Won Opportunities"
            body={drilldownOnGraphData}
            handleSecondLevelDrilldown={handleSecondLevelDrilldown}
          />
        </SingleLevelDrilldown>
      )}

      {/* Second Level Drilldown (Individual Opportunity) */}
      {secondLevelLocation === LOCATIONS.OPP_DETAILS && (
        <SingleLevelDrilldown
          header=""
          back={handleChangeLocationBack}
          stepBack={stepBack}
          filters={[]}
        >
          {drilldownLocation === LOCATIONS.QUALIFIED_PIPELINE ? (
            <ExpectedAcvPageLegacy
              Value_Label={Value_Label}
              data={ExpectedAcvData}
              opp={true}
              company={company}
              Win_Rate_Prefix={Win_Rate_Prefix}
            />
          ) : (
            <ExpectedAcvPageWaterfall
              Value_Label={Value_Label}
              body={ExpectedAcvData}
              opp={true}
              company={company}
              Win_Rate_Prefix={Win_Rate_Prefix}
            />
          )}
        </SingleLevelDrilldown>
      )}
    </>
  );
}

